function About() {
  return (
    <>
      <h1 className="text-6xl mb-4">Github Finder</h1>
      <p className="mb-4 text-2xl font-light">
        A React app to search GitHub profiles and see profile details. This
        project is for learning purpose.
      </p>
      <p className="mb-4 text-2xl font-light">
        Created by: <a href="https://nikhilmandaliya.github.io/" target="_blank">Nikhil </a> and <a href="https://nikhilso1anki.github.io/" target="_blank"> Nikhil</a>
      </p>
      <p className="text-lg text-neutral-400">
        Version <span className="text-black">1.0.0</span>
      </p>
    </>
  );
}

export default About;
